import type { SelfEmployedTransactionListItem } from '@/shared/api'

export type THistoryDay = {
    dateKey: string
    title: string
    transactions: SelfEmployedTransactionListItem[]
}

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate())

const toDayKey = (createdAt: string) => {
    const date = new Date(createdAt)

    if (Number.isNaN(date.getTime())) {
        return createdAt
    }

    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`
}

const formatDayTitle = (createdAt: string) => {
    const date = new Date(createdAt)

    if (Number.isNaN(date.getTime())) {
        return createdAt
    }

    const day = startOfDay(date)
    const today = startOfDay(new Date())
    const yesterday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1)

    if (day.getTime() === today.getTime()) {
        return 'Сегодня'
    }

    if (day.getTime() === yesterday.getTime()) {
        return 'Вчера'
    }

    return new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        ...(day.getFullYear() === today.getFullYear() ? {} : { year: 'numeric' }),
    }).format(day)
}

export const groupTransactionsByDate = (transactions: SelfEmployedTransactionListItem[]) => {
    const seen = new Set<string>()
    const days: THistoryDay[] = []

    for (const transaction of transactions) {
        if (seen.has(transaction.id)) {
            continue
        }

        seen.add(transaction.id)

        const dateKey = toDayKey(transaction.created_at)
        const lastDay = days.at(-1)

        if (lastDay?.dateKey === dateKey) {
            lastDay.transactions.push(transaction)
            continue
        }

        days.push({
            dateKey,
            title: formatDayTitle(transaction.created_at),
            transactions: [transaction],
        })
    }

    return days
}
